import { useAppSelector } from "store";
import styled from "@emotion/styled";
import { Col, Form, Input, Row, Switch } from "antd";
import React, { FC, useEffect, useState } from "react";

interface ProductIsRecommendProps {
  is_recommend: boolean;
  setCheckIsRecommend: (checkIsRecommend: boolean) => void;
  checkIsActive: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
  checkIsApproved: boolean;
  setCheckIsApproved: (checkIsApproved: boolean) => void;
  checkIsShowApp: boolean;
  setCheckIsShowApp: (checkIsShowApp: boolean) => void;
}

const ProductIsRecommend: FC<ProductIsRecommendProps> = (
  {
    is_recommend,
    setCheckIsRecommend,
    checkIsActive,
    setCheckIsActive,
    checkIsApproved,
    setCheckIsApproved,
    checkIsShowApp,
    setCheckIsShowApp,
  }) => {
  const userProfile = useAppSelector((state) => state.auth.profile);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (userProfile?.user.role.ref_type === "admin") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [userProfile]);

  return (
    <FormWrapper>
      <Row gutter={16} justify="space-between">
        {isAdmin && (
          <Col span={6}>
            <Form.Item
              label="อนุมัติสินค้า"
              name="is_approve"
              valuePropName="checked"
            // rules={[{ required: false, message: "กรุณาเลือกสินค้าแนะนำ" }]}
            >
              <Switch
                onChange={(value) => {
                  setCheckIsApproved(value);
                }}
              />
            </Form.Item>
          </Col>
        )}

        {isAdmin && (
          <Col span={6}>
            <Form.Item
              label="เปิดการมองเห็นสินค้า"
              name="is_active"
              valuePropName="checked"
            // rules={[{ required: false, message: "กรุณาเลือกสินค้าแนะนำ" }]}
            >
              <Switch
                onChange={(value) => {
                  setCheckIsActive(value);
                }}
              />
            </Form.Item>
          </Col>
        )}

        {/* สินค้าแนะนำ + สินค้าค้างสต๊อก อยู่ติดกันเสมอ (ไม่ให้ space-between ดันแยกกัน) */}
        <Col span={6}>
          <SwitchGroup>
            <Form.Item
              label="สินค้าแนะนำ"
              name="is_recommend"
              valuePropName="checked"
            // rules={[{ required: false, message: "กรุณาเลือกสินค้าแนะนำ" }]}
            >
              <Switch
                onChange={(value) => {
                  setCheckIsRecommend(value);
                }}
              />
            </Form.Item>

            <Form.Item
              label="สินค้าค้างสต๊อก"
              name="is_dead_stock"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </SwitchGroup>
        </Col>

        {isAdmin && (
          <Col span={6}>
            <Form.Item
              label="เปิดการมองเห็นสินค้าในแอป"
              name="is_show_app"
              valuePropName="checked"
            // rules={[{ required: false, message: "กรุณาเลือกสินค้าแนะนำ" }]}
            >
              <Switch
                onChange={(value) => {
                  setCheckIsShowApp(value);
                }}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </FormWrapper>
  );
};

export default ProductIsRecommend;

const SwitchGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  white-space: nowrap;
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  margin-bottom: 10px;
  border-radius: 8px;
`;
